import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { hideNotify } from '../../redux/notify/notify.actions';
import { selectNotify } from '../../redux/notify/notify.selectors';

import './Notify.scss';

export const Notify = ({ viewType }) => {
    const { id = null, visible: isOpen, message: messageCode, timestamp: startTimestamp } = useSelector(selectNotify);

    const timeoutRef = useRef(null);
    const lastIdRef = useRef(id);

    const dispatch = useDispatch();
const { t, i18n } = useTranslation();

    const [shouldRender, setShouldRender] = useState(isOpen);
    const [animationClass, setAnimationClass] = useState('');

    useEffect(() => {
        if (isOpen) {
            setShouldRender(true);
            setAnimationClass('fade-in-notify');
        } else if (shouldRender) {
            setAnimationClass('fade-out-notify');
        }
    }, [isOpen]);

    const handleAnimationEnd = () => {
        if (!isOpen) {
            setShouldRender(false);
        }
    };

    useEffect(() => {
        if (!id) return;

        let currentTimestamp = Date.now();
        let timePassed = currentTimestamp - startTimestamp;

        if (timePassed >= 500) {
            dispatch(hideNotify());
        }

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            dispatch(hideNotify());
        }, 3000);

        lastIdRef.current = id;

        return () => clearTimeout(timeoutRef.current);
    }, [id]);

    if (!shouldRender) return null;

    return (
        <div className={`notify ${viewType ? viewType : ''} ${animationClass}`} onAnimationEnd={handleAnimationEnd}>{t(`n.${messageCode || 'default'}`)}</div>
    );
};

export default Notify;
